
import React from 'react';
import HeroSection from '@/components/home/HeroSection';
import FeaturesSection from '@/components/home/FeaturesSection';
import SecuritySection from '@/components/products/SecuritySection';
import NavBar from '@/components/layout/NavBar';
import Footer from '@/components/layout/Footer';
import SEO from '@/components/seo/SEO';

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        canonicalPath="/" 
        description="Keystle provides innovative identity management solutions for workforce, business, and customer identity access management."
        keywords="identity management, IAM, authentication, security, SSO, MFA, passwordless"
      />
      <NavBar />
      <main className="flex-grow">
        <HeroSection />
        <FeaturesSection />
        <SecuritySection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
